export default {
  header: {
    back: {
      url: 'http://chaumet.com/jp',
      content: 'Chaumet.comに戻る'
    }
  },
  playerCover: {
    title:
      '「ショーメ　時空を超える宝飾芸術の世界<span class="liner-rotate">-</span>1780年に始まるエスプリ」展',
    content: '2018年6月28日から9月17日まで',
    idYt: 'aXMgQ6xpdPg',
    cover: 'home/player/cover.jpg',
    legend: 'Video'
  },
  scrollCta: 'スクロールして詳細を見る',
  worldDiscover: {
    title: {
      firstPart: '詳細を見る',
      secondPart: 'ショーメの世界'
    },
    content:
      '東京三菱一号館美術館にて開催される美術展を通して、ショーメの歴史と伝統、比類ないサヴォワールフェールを巡る新たな旅へ皆様をご招待します。',
    worlds: {
      types: [
        {
          title: 'ジョゼフィーヌ',
          content: 'ショーメウーマン、ショーメのミューズ',
          img: 'home/world/josephine.jpg',
          url: 'josephine'
        },
        {
          title: 'メゾンショーメ',
          content: 'ヴァンドーム広場12番地の最初のジュエラー',
          img: 'home/world/chaumet.jpg',
          url: 'maison'
        },
        {
          title: 'ショーメと日本',
          content: '旅への招待',
          img: 'home/world/japon.jpg',
          url: 'japan'
        },
        {
          title: '自然',
          content: '尽きることのないインスピレーションの源',
          img: 'home/world/nature.jpg',
          url: 'nature'
        },
        {
          title: 'ティアラの芸術',
          content: '頭上を飾るクリエーション',
          img: 'home/world/art.jpg',
          url: 'tiara'
        },
        {
          title: '君主が選ぶ物',
          content: '教皇ピウス7世のティアラ、権力の象徴',
          img: 'home/world/pape.jpg',
          url: 'sovereigns'
        },
        {
          title: '想いをあらわすジュエリー',
          content: '形を変えるジュエリーの芸術',
          img: 'home/world/sentimental.jpg',
          url: 'sentimental'
        },
        {
          title: '幸せに満ちた瞬間に寄り添う ',
          content: 'サヴォワールフェールと卓越性',
          img: 'home/world/transformer.jpg',
          url: 'transformer'
        }
      ],
      cta: '詳細を見る'
    },
    legend: 'Worlds'
  },
  wall: {
    title: '#TheWorldsOfChaumet',
    content:
      '本展では、19世紀後半からショーメが世界へ目を向け、多様な文化的影響を受けながら独自のパリスタイルを広めた軌跡や、装飾様式の歴史において主要な役割を担っていく過程をご覧頂けます。また、日本と日本文化に特別な敬意を表し、18世紀の終わりから続く日本との強い結びつきをご紹介します。',
    previous: '戻る',
    next: '次へ',
    cta: 'see more',
    legend: '#TheWorldsOfChaumet'
  },
  footer: {
    title: '開催情報',
    exposition: {
      title:
        '「ショーメ　時空を超える宝飾芸術の世界‐1780年に始まるエスプリ」展',
      content: '2018年6月28日から9月17日まで、東京の三菱一号館美術館にて。'
    },
    museum: {
      link: {
        title: '美術館のサイトにアクセス',
        url: 'https://mimt.jp/chaumet/'
      },
      logo: 'home/museum-logo.png'
    },
    legend: '開催情報',
    links: [
      { logo: 'social/fb.png', url: 'https://www.facebook.com/Chaumet' },
      {
        logo: 'social/insta.png',
        url: 'https://www.instagram.com/chaumetofficial/'
      },
      { logo: 'social/yt.png', url: 'https://youtube.com/user/Chaumet' },
      { logo: 'social/gplus.png', url: 'https://plus.google.com/+chaumet' },
      { logo: 'social/pint.png', url: 'https://www.pinterest.fr/chaumet/' },
      { logo: 'social/twitter.png', url: 'https://twitter.com/Chaumet' },
      {
        logo: 'social/line.png',
        url: 'https://line.me/R/ti/p/%40chaumetofficial'
      },
      { logo: 'social/wechat.png' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/locales/jp/home.js